import React from "react";
import { Link, useLocation } from "wouter";

const BottomNavigation: React.FC = () => {
  const [location] = useLocation();

  const isActive = (path: string) => {
    return location === path ? "text-primary" : "text-gray-500";
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center py-2 z-10 max-w-md mx-auto">
      <Link href="/">
        <div className={`flex flex-col items-center p-2 ${isActive("/")}`}>
          <span className="material-icons">home</span>
          <span className="text-xs mt-1">Home</span>
        </div>
      </Link>
      <Link href="/exercises">
        <div
          className={`flex flex-col items-center p-2 ${isActive("/exercises")}`}
        >
          <span className="material-icons">fitness_center</span>
          <span className="text-xs mt-1">Exercises</span>
        </div>
      </Link>
      <Link href="/progress">
        <div
          className={`flex flex-col items-center p-2 ${isActive("/progress")}`}
        >
          <span className="material-icons">insert_chart</span>
          <span className="text-xs mt-1">Progress</span>
        </div>
      </Link>
    </nav>
  );
};

export default BottomNavigation;
